(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          //card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  // --- Variant cards patch (no fetch): update links + image + stop theme jump ---
(() => {
  const root = document.getElementById('ResultsList');
  if (!root) return;

  function isQuickAddOrControl(target) {
    return !!target.closest(
      'button, form, input, select, textarea, [data-quick-add], add-to-cart-component, .quick-add, .product-card__quick-add'
    );
  }

  function patch() {
    const items = root.querySelectorAll('li[data-variant-url]');
    if (!items.length) return;

    items.forEach((el) => {
      if (el.dataset.variantPatched === '1') return;

      const targetUrl = el.dataset.variantUrl;
      const imgSrc = (el.dataset.variantImage || '').trim();

      // Update both theme links
      const links = [
        el.querySelector('a[ref="cardGalleryLink"]'),
        el.querySelector('a[ref="productTitleLink"]'),
      ].filter(Boolean);

      links.forEach((a) => {
        a.setAttribute('href', targetUrl);

        const handler = (e) => {
          // allow new tab / modifiers
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
          if (isQuickAddOrControl(e.target)) return;

          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          window.location.assign(targetUrl);
        };

        // Stop theme navigation early (prevents jump)
        a.addEventListener('pointerdown', handler, true);
        a.addEventListener('click', handler, true);
      });

      // Swap image if we have variant image
      if (imgSrc) {
        el.querySelectorAll('source').forEach((s) => s.removeAttribute('srcset'));
        const img = el.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.src = imgSrc;
        }
      }

      el.dataset.variantPatched = '1';
    });
  }

  // Run now + after filters/infinite scroll updates
  const run = () => patch();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver(() => {
    clearTimeout(window.__variantPatchT);
    window.__variantPatchT = setTimeout(patch, 100);
  }).observe(root, { childList: true, subtree: true });

  setTimeout(patch, 300);
  setTimeout(patch, 1000);
})();


  } catch(e) { console.error(e); }
})();
})();
